(() => {
  const root = document.querySelector('.mc-pdp--fr');
  if (!root) return;
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-colors-toggle]');
    if (toggle && root.contains(toggle)) {
      queueMicrotask(() => { toggle.textContent = toggle.getAttribute('aria-expanded') === 'true' ? 'Voir moins de couleurs' : 'Voir plus de couleurs'; });
    }
  });
})();
